import { type DataRoomAuditLog } from "@decentriq/core";
import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { useApiCore } from "contexts";
import {
  useMediaDataRoom,
  useMediaDataRoomInsightsData,
} from "features/mediaDataRoom/contexts";
import { MediaDataRoomVersion } from "features/mediaDataRoom/models";

type MediaDataRoomAuditLogsHookResult = UseQueryResult<DataRoomAuditLog>;

const useMediaDataRoomAuditLogs = (): MediaDataRoomAuditLogsHookResult => {
  const { dataRoomId } = useMediaDataRoom();
  const { client, getVerificationKey } = useApiCore();
  const { session } = useMediaDataRoomInsightsData(MediaDataRoomVersion.v3);
  return useQuery<DataRoomAuditLog>({
    enabled: Boolean(session),
    queryFn: async () => {
      const verificationKey = await getVerificationKey(session);
      const auditLogs = await client.getDataRoomAuditLog(
        dataRoomId,
        verificationKey
      );
      return auditLogs;
    },
    queryKey: ["v0", "dataRoom", dataRoomId, "auditLogs"],
  });
};

export default useMediaDataRoomAuditLogs;
